import { Touchpoint } from '../../../../../../api/services/mediaPlanning/touchpoints';

const prepareAvailableTouchpoints = (touchpoints: Touchpoint[]): string[] => {
  const uniqueNames = new Set<string>();
  touchpoints.forEach((element) => {
    uniqueNames.add(element.TouchpointName);
  });

  return Array.from(uniqueNames);
};

export default prepareAvailableTouchpoints;
